import { ReconnectingWebSocket } from "./websocket";

export const WS = new ReconnectingWebSocket("", [], { startClosed: true });
